import { ReactElement } from 'react';

export default function PlacementBadge(): ReactElement {
	return (
		<div className='absolute bottom-0 left-1/2 grid h-8 w-8 -translate-x-1/2 translate-y-1/2 place-items-center rounded-full bg-[#F82D79] text-xl font-bold leading-none text-white'>
			+
		</div>
	);
}
